/**
 * Vanilla js implementation of lodash sumBy (2.5x faster).
 */

export const sumBy = <T>(arr: T[], func: (item: T) => number): number =>
  arr.reduce((acc, item) => acc + func(item), 0)
